import React from 'react'
import styled from 'styled-components'
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';


const Star = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: small;
    cursor: pointer;
    width: 100%;

    transition: 0.2s ease-in-out;

`

const StarWrapper = styled.div`
    max-width: 300px;
    display: grid;
    grid-gap: 5px;
    grid-template-columns: 30px 30px 30px 30px 30px;
`

function RatingInput(props) {
    let { value, onChange } = props;

    return (
        <StarWrapper>
            <Star onClick={() => onChange(1)}>

                {value >= 1 ? <StarIcon fontSize={"large"} style={{ color: "#F2C366" }} /> : <StarBorderIcon fontSize={"large"} style={{ color: "#F2C366" }} />}
            </Star>
            <Star onClick={() => onChange(2)} >



                {value >= 2 ? <StarIcon fontSize={"large"} style={{ color: "#F2C366" }} /> : <StarBorderIcon fontSize={"large"} style={{ color: "#F2C366" }} />}
            </Star>

            <Star onClick={() => onChange(3)}>

                {value >= 3 ? <StarIcon fontSize={"large"} style={{ color: "#F2C366" }} /> : <StarBorderIcon fontSize={"large"} style={{ color: "#F2C366" }} />}
            </Star>

            <Star onClick={() => onChange(4)}>

                {value >= 4 ? <StarIcon fontSize={"large"} style={{ color: "#F2C366" }} /> : <StarBorderIcon fontSize={"large"} style={{ color: "#F2C366" }} />}
            </Star>

            <Star onClick={() => onChange(5)}>


                {value >= 5 ? <StarIcon fontSize={"large"} style={{ color: "#F2C366" }} /> : <StarBorderIcon fontSize={"large"} style={{ color: "#F2C366" }} />}
            </Star>

        </StarWrapper>
    )
}


RatingInput.defaultProps = {
    value: 0,
    onChange: () => { }
};

export default RatingInput